import ApiService from 'global/utils/ApiService';
import endpointUrls from 'global/Constants/endpointUrls';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { AppDispatch } from 'redux/store';
import { pickupType } from 'global/Models/omOrderModel';
import { setOrderPickupTypes } from 'redux/reducer/ParcelOrder/parcelOrderReducer';

export const getPickupTypes = () => async (dispatch: AppDispatch) => {
  await ApiService.post(endpointUrls.pickupTypeGetAll, { recordsPerPage: 50 })
    .then((res: IBackendSearchGeneric<pickupType>) => {
      res.isSuccess && dispatch(setOrderPickupTypes(res.data));
    })
    .catch(() => {});
};
